export enum KeySet {
  KEY_RIGHT = "KEY_RIGHT",
  KEY_LEFT = "KEY_LEFT",
  KEY_DOWN = "KEY_DOWN",
  KEY_UP = "KEY_UP",

  KEY_ENTER = "KEY_ENTER",
  KEY_BACK = "KEY_BACK", // 'backspace' '65385' is the back button when virtual keyboard is open
  KEY_SPACE = "KEY_SPACE",
  KEY_ESC = "KEY_ESC",

  KEY_CHANNEL_PLUS = "KEY_CHANNEL_PLUS",
  KEY_CHANNEL_MINUS = "KEY_CHANNEL_MINUS",

  /* player */
  KEY_PLAY_PAUSE = "KEY_PLAY_PAUSE",
  KEY_PAUSE = "KEY_PAUSE",
  KEY_PLAY = "KEY_PLAY",
  KEY_STOP = "KEY_STOP",
  KEY_FASTER = "KEY_FASTER",
  KEY_SLOWER = "KEY_SLOWER",
  KEY_REC = "KEY_REC",

  /* numerics */
  KEY_NUMERIC_0 = "KEY_NUMERIC_0",
  KEY_NUMERIC_1 = "KEY_NUMERIC_1",
  KEY_NUMERIC_2 = "KEY_NUMERIC_2",
  KEY_NUMERIC_3 = "KEY_NUMERIC_3",
  KEY_NUMERIC_4 = "KEY_NUMERIC_4",
  KEY_NUMERIC_5 = "KEY_NUMERIC_5",
  KEY_NUMERIC_6 = "KEY_NUMERIC_6",
  KEY_NUMERIC_7 = "KEY_NUMERIC_7",
  KEY_NUMERIC_8 = "KEY_NUMERIC_8",
  KEY_NUMERIC_9 = "KEY_NUMERIC_9"
}
